/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Sso_RequiredInputs */



/**
* | output |
* | --- |
* | "Your organisation doesn't use sign-in links. Use one of the buttons above." |
*
* @param {Login_Sso_RequiredInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_sso_required = /** @type {((inputs?: Login_Sso_RequiredInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Sso_RequiredInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je organisatie gebruikt geen aanmeldlinks. Gebruik een van de knoppen hierboven.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre organisation n'utilise pas les liens de connexion. Utilisez l'un des boutons ci-dessus.")
	return /** @type {LocalizedString} */ ("Your organisation doesn't use sign-in links. Use one of the buttons above.")
});